import Vue from 'vue'
import Router from 'vue-router'

const mutationContext = require.context('./routes', false, /.*\.js/)
const routes = mutationContext.keys().reduce((acc, path) => {
  const _path = path.replace('./', '')
  acc.push(...require(`./routes/${_path}`).default)
  return acc
}, [])

Vue.use(Router)

const RouterConfig = {
  mode: 'history',
  base: process.env.BASE_API,
  routes: [
    ...routes
  ],
  linkActiveClass: 'active-link wx-shop-text', // 点击进行路由跳转时那个路由会添加active-link
  linkExactActiveClass: 'exact-active-link wx-shop-text', // 路由路径完全匹配是点击的时候会有exact-active-link
  scrollBehavior (to, from, savedPosition) {
    // 记录路由页面滚动的位置
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  fallback: true // 如果浏览器不支持history模式，那么自动帮我们改为hash模式
}
export const router = new Router(RouterConfig)

router.beforeEach((to, from, next) => {
  next()
})
// 路由错误处理防止缓存加载错误文件
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    window.location.reload()
  } else {
    console.log(error)
  }
})
